// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__211OB","insightsList":"newBusinessInsightsMenu_insightsList__36LDf","active":"newBusinessInsightsMenu_active__3voQ3"};